import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollProgress from "./ScrollProgress";
import BackToTop from "./BackToTop";
import FloatingWhatsApp from "./FloatingWhatsApp";
import MobileStickyCta from "./MobileStickyCta";
import AssistantWidget from "./AssistantWidget";

export default function Layout() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="flex min-h-screen flex-col bg-background">
            <ScrollProgress />
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <AssistantWidget />
            <BackToTop />
            <MobileStickyCta />
        </div>
    );
}
